import { PartyContactMechanisms } from '../../party/model/party-contact-mechanisms.model';
import { partyContactMechanismInterface } from '../../party/view-party-contact-mechanism/view-party-contact-mechanism.component';

export interface PARTy {
    ID: number;
    PARTY_CONTACT_MECHANISMS: PartyContactMechanisms[];
}

export interface PERSON {
    ID: number;
    PARTIES_ID: number;
    LAST_NAME: string;
    FIRST_NAME: string;
    MIDDLE_INITIAL: string;
    SECOND_LAST_NAME: string;
    PARTy: PARTy;
}

export class STUDENT {
    ID: number;
    PERSONS_ID: number;
    MSD_NUMBER: string;
    PERSON: PERSON;    
}

export class COESTUDENT {
    STUDENTS_ID: number;
    COES_ID: number;
    STUDENT: STUDENT;
}

export interface CoeRelatedStudent {
    ID: number;
    COE_NUMBER: string;
    COE_STUDENTS: COESTUDENT[];
}
